import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLOR.GRAY200.code};
  padding: 6px 10px 10px;
  width: 100%;
`;

export const DivMenuItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AnchorFANZA = styled.a`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 34px;
  text-decoration: none;
  border: 1px solid #ff5a6e;
  color: #ff5a6e;
  width: 100px;
  border-radius: 20px;
  padding: 4px 0 6px;
  text-align: center;
`;

export const SpanText = styled.span<{ fontSize?: number }>`
  ${({ fontSize }) => fontSize && `font-size:${fontSize}px;`}
  :first-of-type {
    line-height: 13px;
  }
  :last-child {
    transform: scale(0.8);
  }
`;
